module.exports = __webpack_public_path__ + "img/label.aa9f15bf.svg";